<div>
    <div class="table-container audit-table">
        <div class="between-center">
            <p class="table-breadcrumb">
                {{ totalPaginatedItems }}
                Results
            </p>
            <div class="end-center">
                <mat-checkbox
                    [checked]="cloudProcessEnabled"
                    class="info-box-checkbox"
                    (click)="toggleCloudProcess()"
                ></mat-checkbox>
                <p>Show Cloud Processes</p>
            </div>
        </div>

        <div [ngStyle]="{ display: isGrouped ? 'none' : 'block' }">
            <table
                mat-table
                [dataSource]="dataSource"
                class="mat-elevation-z1 log-table"
                multiTemplateDataRows
                matSort
                (matSortChange)="onSortChange($event)"
                [ngStyle]="{
                    'min-height': dataSource.data.length === 0 ? '300px' : 'auto',
                }"
            >
                <!-- Date & Time Column -->
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        <p class="table-header">Date & Time</p>
                    </th>
                    <td mat-cell *matCellDef="let log">
                        <p class="table-cell">
                            {{ log.date | date: "dd/MM/yyyy HH:mm:ss" }}
                        </p>
                    </td>
                </ng-container>

                <!-- User Column -->
                <ng-container matColumnDef="user">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        <p class="table-header">User</p>
                    </th>
                    <td mat-cell *matCellDef="let log" class="user-td">
                        <div class="between-center">
                            <div
                                [ngClass]="{
                                    'tooltip-wrapper': isOverflowed(userRef),
                                }"
                                style="width: 100%"
                            >
                                <p
                                    #userRef
                                    class="table-cell user-cell"
                                    [ngStyle]="{
                                        'font-weight':
                                            log.user === 'Unknown'
                                                ? '400'
                                                : '600',
                                    }"
                                >
                                    {{
                                        log.user === "Unknown"
                                            ? "Cloud Process"
                                            : log.user
                                    }}
                                </p>
                                <div class="tooltip-text">
                                    <p
                                        [ngStyle]="{
                                            'font-weight':
                                                log.user === 'Unknown'
                                                    ? '400'
                                                    : '600',
                                        }"
                                    >
                                        {{
                                            log.user === "Unknown"
                                                ? "Cloud Process"
                                                : log.user
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </td>
                </ng-container>

                <!-- Activity Column -->
                <ng-container matColumnDef="activity">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        <p class="table-header">Activity</p>
                    </th>
                    <td mat-cell *matCellDef="let log" class="activity-td">
                        <div class="start-center">
                            <p
                                class="activity-chip"
                                [ngStyle]="{
                                    'background-color': log.activity.color,
                                }"
                            >
                                {{ log.activity.activity }}
                            </p>
                            <div
                                [ngClass]="{
                                    'tooltip-wrapper':
                                        isOverflowed(activityRef),
                                }"
                            >
                                <p
                                    #activityRef
                                    class="table-cell activity-detail"
                                >
                                    [
                                    <span>{{ log.activity.caption }}</span>
                                    <span
                                        *ngIf="log.activity?.redirection?.text"
                                    >
                                        {{ readableNavigationFormat(log) }} |
                                    </span>
                                    <span
                                        *ngIf="log.activity?.redirection?.text"
                                        [ngClass]="{
                                            'activity-url':
                                                log.activity.redirection.link,
                                        }"
                                        (click)="openUrl(log)"
                                    >
                                        {{
                                            readableLink(
                                                log.activity?.redirection?.text
                                            )
                                        }}
                                    </span>
                                    <span
                                        *ngIf="
                                            log.activity?.redirection?.duration
                                        "
                                    >
                                        |
                                    </span>
                                    <span
                                        *ngIf="
                                            log.activity?.redirection?.duration
                                        "
                                    >
                                        {{
                                            log.activity?.redirection?.duration
                                        }}
                                        mins
                                    </span>
                                    ]
                                </p>
                                <div class="tooltip-text">
                                    [
                                    <span>{{ log.activity.caption }}</span>
                                    <span
                                        *ngIf="log.activity?.redirection?.text"
                                    >
                                        |
                                    </span>
                                    <span
                                        *ngIf="log.activity?.redirection?.text"
                                        [ngClass]="{
                                            'activity-url':
                                                log.activity.redirection.link,
                                        }"
                                        (click)="openUrl(log)"
                                    >
                                        {{ log.activity?.redirection?.text }}
                                    </span>
                                    <span
                                        *ngIf="
                                            log.activity?.redirection?.duration
                                        "
                                    >
                                        |
                                    </span>
                                    <span
                                        *ngIf="
                                            log.activity?.redirection?.duration
                                        "
                                    >
                                        {{
                                            log.activity?.redirection?.duration
                                        }}
                                        mins
                                    </span>
                                    ]
                                </div>
                            </div>
                        </div>
                    </td>
                </ng-container>

                <!-- Header and Row Declarations -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                ></tr>
            </table>
        </div>
        <!-- GROUPED TABLE -->
        <div [ngStyle]="{ display: !isGrouped ? 'none' : 'block' }">
            <table
                mat-table
                [dataSource]="groupedTableDataSource"
                class="mat-elevation-z1 log-table"
                multiTemplateDataRows
            >
                <colgroup>
                    <col style="width: 20%" />
                    <col style="width: 25%" />
                    <col style="width: 55%" />
                </colgroup>
                <!-- Group Header Row -->
                <ng-container matColumnDef="groupHeader">
                    <td
                        mat-cell
                        *matCellDef="let row"
                        [attr.colspan]="displayedColumns.length"
                        class="group-header pointer"
                        (click)="toggleGroup(row.groupId)"
                    >
                        <div class="between-center">
                            <p class="table-header">
                                {{
                                    row.user.fullname === "Unknown"
                                        ? "Cloud Process"
                                        : row.user.fullname
                                }}

                                [ Session
                                {{
                                    row.startDate | date: "dd/MM/yyyy HH:mm:ss"
                                }}
                                ]
                            </p>
                            <div class="center expand-button">
                                <div
                                    [ngClass]="
                                        row.expanded
                                            ? 'triangle-down'
                                            : 'triangle-right'
                                    "
                                ></div>
                            </div>
                        </div>
                    </td>
                </ng-container>

                <!-- Date Column -->
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef>
                        <p class="table-header">Date & Time</p>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <p class="table-cell">
                            {{ row.log?.date | date: "dd/MM/yyyy | HH:mm:ss" }}
                        </p>
                    </td>
                </ng-container>

                <!-- User Column -->
                <ng-container matColumnDef="user">
                    <th mat-header-cell *matHeaderCellDef>
                        <p class="table-header">User</p>
                    </th>
                    <td mat-cell *matCellDef="let row" class="user-td">
                        <div class="between-center">
                            <div
                                [ngClass]="{
                                    'tooltip-wrapper': isOverflowed(userRef),
                                }"
                                style="width: 100%"
                            >
                                <p
                                    #userRef
                                    class="table-cell user-cell"
                                    [ngStyle]="{
                                        'font-weight':
                                            row.log?.user === 'Unknown'
                                                ? '400'
                                                : '600',
                                    }"
                                >
                                    {{
                                        row.log?.user === "Unknown"
                                            ? "Cloud Process"
                                            : row.log?.user
                                    }}
                                </p>
                                <div class="tooltip-text">
                                    <p
                                        [ngStyle]="{
                                            'font-weight':
                                                row.log?.user === 'Unknown'
                                                    ? '400'
                                                    : '600',
                                        }"
                                    >
                                        {{
                                            row.log?.user === "Unknown"
                                                ? "Cloud Process"
                                                : row.log?.user
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </td>
                </ng-container>

                <!-- Activity Column -->
                <ng-container matColumnDef="activity">
                    <th mat-header-cell *matHeaderCellDef>
                        <p class="table-header">Activity</p>
                    </th>

                    <td mat-cell *matCellDef="let row" class="activity-td">
                        <div class="start-center" *ngIf="!row.isGroup">
                            <p
                                class="activity-chip"
                                [ngStyle]="{
                                    'background-color': row.log.activity.color,
                                }"
                            >
                                {{ row.log.activity.activity }}
                            </p>
                            <div
                                [ngClass]="{
                                    'tooltip-wrapper':
                                        isOverflowed(activityRef),
                                }"
                            >
                                <p
                                    class="table-cell activity-detail"
                                    #activityRef
                                >
                                    [ {{ row.log.activity.caption }}
                                    <span
                                        *ngIf="
                                            row.log.activity?.redirection?.text
                                        "
                                        [ngClass]="{
                                            'activity-url':
                                                row.log.activity.redirection
                                                    .link,
                                        }"
                                        (click)="openUrl(row)"
                                    >
                                        |
                                        {{
                                            row.log.activity?.redirection?.text
                                        }}</span
                                    >
                                    <span
                                        *ngIf="
                                            row.log.activity?.redirection
                                                ?.duration
                                        "
                                    >
                                        |
                                        {{
                                            row.log.activity?.redirection
                                                ?.duration
                                        }}</span
                                    >
                                    ]
                                </p>
                                <div class="tooltip-text">
                                    [ {{ row.log.activity.caption }}
                                    <span
                                        *ngIf="
                                            row.log.activity?.redirection?.text
                                        "
                                        [ngClass]="{
                                            'activity-url':
                                                row.log.activity.redirection
                                                    .link,
                                        }"
                                        (click)="openUrl(row)"
                                    >
                                        |
                                        {{
                                            row.log.activity?.redirection?.text
                                        }}</span
                                    >
                                    <span
                                        *ngIf="
                                            row.log.activity?.redirection
                                                ?.duration
                                        "
                                    >
                                        |
                                        {{
                                            row.log.activity?.redirection
                                                ?.duration
                                        }}</span
                                    >
                                    ]
                                </div>
                            </div>
                        </div>
                    </td>
                </ng-container>
                <!-- Header Row -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

                <!-- Row definitions -->
                <tr
                    mat-row
                    *matRowDef="
                        let row;
                        columns: ['groupHeader'];
                        when: isGroupHeader
                    "
                    class="group-row"
                ></tr>
                <tr
                    mat-row
                    *matRowDef="
                        let row;
                        columns: displayedColumns;
                        when: isDataRow
                    "
                ></tr>
            </table>
        </div>

        <div *ngIf="dataSource.data.length === 0" class="no-data center">
            <p class="no-data-text">
                No activity recorded for this user(s) in this period.
            </p>
        </div>

        <mat-paginator
            [pageSize]="pageSize"
            [pageIndex]="pageIndex"
            [pageSizeOptions]="[5, 10, 25, 50, 100]"
        ></mat-paginator>
    </div>
</div>
